module.exports = __webpack_public_path__ + "img/taptap_banner.0e62df1e.png";